import { environment } from './../../../../../environment/environment';
import { EsnCandidatService } from './../../../../core/services/esn-candidat/esn-candidat.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { serverError } from './../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { DatePipe } from '@angular/common';
import { listContracts } from './../../../../core/models/candidat';
import { CvType } from '@core/models/enums/cv-type.enum';
import { LocalStorageService } from '@core/services/local-storage.service';
import { SubscriptionService } from '@core/services/subscription.service';
import { ExportService } from '@shared/services/export.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
const DOMPurify = require('dompurify')
@Component({
  selector: 'app-profilcandidat',
  templateUrl: './profilcandidat.component.html',
  styleUrls: ['./profilcandidat.component.css'],
})
export class ProfilcandidatComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  mailImage = 'assets/image_cv/email-svg.svg';
  linkedinImage = 'assets/image_cv/linkedin.svg';
  locationImage = 'assets/image_cv/location.svg';
  telephoneImage = 'assets/image_cv/telephone.svg';
  aboutImage = 'assets/image_cv/about-icon.svg';
  skillsImage = 'assets/image_cv/skills-image.png';
  softSkillsImage = 'assets/image_cv/softSkills.png';
  starImage='assets/image_cv/start.svg';
  starinactiveImage='assets/image_cv/star-inactive.svg';
  imageLogo='assets/media/logos/logo-wegestu-color.png'; 
  experienceImage='assets/image_cv/experience-image.svg';
  graduationImage='assets/image_cv/graduation-svg.svg';
  certificateImage='assets/image_cv/certificate.svg';
  languageImage='assets/image_cv/language.svg';
  baseUrl_Company = environment.baseUrlGaleryCompany
  /* string */
  url: string = environment.baseUrl;
  isLastPagee: boolean = false;
  hasPagination: boolean = false;
  isEmptyList: boolean = false;
  pagination : boolean =false;

  /* number */

  /* number */
  totalItems!: number;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  /* object */
  selectedCandidate!: any;
  /* array */
  contratRequest = listContracts;
  linkedinPrefix = 'https://www.linkedin.com/in/';
  skills: any = [];
  skillsCv:any
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  idCandidat = this.activatedRoute.snapshot.params['id'];
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();

  readonly ESN_CONSULTANT_ROLE  = "4"
  cvTypeEnum  = CvType
  currentUser:any

  constructor(
    private activatedRoute: ActivatedRoute,
    private candidatService: EsnCandidatService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private localStorageService: LocalStorageService,
    private subscriptionService: SubscriptionService,
    private exportService: ExportService,
    private sanitizer: DomSanitizer
  ) {}
  ngOnInit() {
    // @ts-ignore
    window.scrollTo(0, 0);
    this.currentUser = JSON.parse(this.localStorageService.getData('UserInfo') || '');
    this.getCandidateById();
    this.getSkills();
  }
  getOldestStartDate(experiences: any[]): Date | null {
  if (!experiences?.length) return null;

  return experiences
    .map(exp => new Date(exp.start_date))
    .sort((a, b) => a.getTime() - b.getTime())[0];
}
  /* get pagination items */
  formatPeriod(period: string): string {
    if (!period) return '';
  
    const matches = period.match(/(\d+) ans, (\d+) mois, (\d+) jours/);
    if (!matches) return period;
  
    const years = parseInt(matches[1], 10);
    const months = parseInt(matches[2], 10);
  
    if (years === 0 && months === 0) {
      return `moins d'un mois`;
    } else {
      let result = '';
  
      if (years > 0) {
        result += `${years} An${years > 1 ? 's' : ''}`;
      }
      if (months > 0) {
        if (result.length > 0) result += ', ';
        result += `${months} Mois`;
      }
  
      return result;
    }
  }
  removeHtmlTags(html: string | undefined): string {
    if (!html) {
      return '';
    }
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html; 
    return tempDiv.textContent || ''; 
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      this.itemsPerPage = event.itemsPerPage;
      this.currentPage = event.currentPage;
      if (this.endIndex > this.totalItems) {
        this.endIndex = this.totalItems;
      }
      if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){
        this.pagination = true
        this.getSkills();

      }
    }
  }
  shouldDisplayCountry(destination_country: any): boolean {
    return Array.isArray(destination_country) && destination_country.some((c) => c !== null);
  }
  shouldDisplayMobility(mobility: any[]): boolean {
    return Array.isArray(mobility) && mobility?.some((m) => m !== null);
  }
  /* get candidate id from route */
  //  getIdCandidat() {
  //    this.activatedRoute.paramMap.subscribe({
  //      next: (params: any) => {
  //        this.idCandidat = this.activatedRoute.snapshot.params['id']
  //        console.log('');

  //        this.getCandidateById()
  //      }
  //    })
  //  }
  /* get candidate by id */
  image: any;
  capitalizeFirstLetter(string:any) {
    if (!string) return string;


    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  getCandidateById(): void {
    this.spinner.show();
    this.candidatService
      .getUserById(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.selectedCandidate = res.data[0];
          this.image = res.data[0]?.image_url;
          // Ensure that desired_contract is an array
          this.selectedCandidate.desired_contract =
            this.selectedCandidate.desired_contract || [];

          // Iterate over desired_contract and map to labels
          this.selectedCandidate.desired_contract =
            this.selectedCandidate.desired_contract.map((contractId: any) => {
              return this.contratRequest[contractId - 1]?.label || '';
            });
          this.selectedCandidate.current_country =
            !this.selectedCandidate.current_country ||
            this.selectedCandidate.current_country == 'null'
              ? ''
              : this.selectedCandidate.current_country;
              
          this.selectedCandidate.linkedin_link =
            !this.selectedCandidate.linkedin_link ||
            this.selectedCandidate.linkedin_link == 'null'
              ? null
              : this.selectedCandidate.linkedin_link;

              
          this.selectedCandidate.date_first_experience =
            !this.selectedCandidate.date_first_experience ||
            this.selectedCandidate.date_first_experience == 'null'
              ? ''
              : this.selectedCandidate.date_first_experience;
          this.selectedCandidate.desired_salary =
            !this.selectedCandidate.desired_salary ||
            this.selectedCandidate.desired_salary == 'null'
              ? ''
              : this.selectedCandidate.desired_salary;
          this.selectedCandidate.destination_country =
            !this.selectedCandidate.destination_country ||
            this.selectedCandidate.destination_country == 'null'
              ? ''
              : this.selectedCandidate.destination_country;

          this.parseData('certificat');
          this.parseData('desired_contract');
          this.parseData('diplome');
          this.parseData('mobility');
          let data: any = [];

          this.selectedCandidate.desired_contract = data;
        },
        error: (err: Error) => {
          this.spinner.hide();
        },
      });
  }
  parseData(name: string) {
    if (
      typeof this.selectedCandidate[name] == 'string' &&
      this.selectedCandidate[name] == 'null'
    ) {
      this.selectedCandidate[name] = [];
    } else {
      if (this.selectedCandidate[name]?.length)
        this.selectedCandidate[name] = JSON.parse(this.selectedCandidate[name]);
    }
  }
  /* open pdf in new target blank */
  OpenPDF(typeFile?: string) {
    this.spinner.show();
    const fileUrl = !typeFile
      ? `${this.url}/api/User/file/gallery_cvs/${this.selectedCandidate.cv}`
      : `${this.url}/api/ResponseCandidate/GetFile/${this.selectedCandidate.file_test}`;
    this.candidatService.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      this.spinner.hide();
      window.open(fileURL, '_blank');
    });
  }
  /* download file */
  downloadFile(typeFile?: string) {
    if (typeFile && typeFile != '')
      // this.selectedCandidate.file_test =
      //   this.selectedCandidate.file_test.split('/')[1];
    this.spinner.show();
    const fileUrl = !typeFile
      ? `${this.url}/api/User/file/gallery_cvs/${this.selectedCandidate.cv}`
      : `${this.url}/api/ResponseCandidate/GetFile/${this.selectedCandidate.file_test}`;
    this.candidatService.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = !typeFile
        ? `${this.selectedCandidate.first_name}_${
            this.selectedCandidate.last_name
          }_CV.${this.selectedCandidate!.cv.split('.').pop()}`
        : `${
            this.selectedCandidate.first_name
          }_${
            this.selectedCandidate.last_name
          }_Réponses_Test_QCM_WEGESTU.${this.selectedCandidate!.file_test.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    });
  }
  /* get candidate skills */
  getSanitizedDescription(description: string): SafeHtml {
    const sanitizedHtml = DOMPurify.sanitize(description);
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }
  getSkills() {
    this.candidatService
      .getSkillsCandidate(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
       

        next: (res) => {
          this.skills = res.data?.categoriesWithSubCategoriesAndSkills;
          this.skillsCv = res.data.categoriesWithSubCategoriesAndSkills
              .map((category:any) => ({
                ...category,
                sub_category: category.sub_category
                  .map((subCategory:any) => ({
                    ...subCategory,
                    skills: subCategory.skills.filter((skill:any) => skill.checked === '1')
                  }))
                  .filter((subCategory:any) => subCategory.skills.length > 0)
              }))
              .filter((category:any) => category.sub_category.length > 0);
  
          const skillsTextLength = this.selectedCandidate?.skills_text?.length ? 1 : 0;
          this.totalItems = res.data.count + skillsTextLength;
        },
        error: () => {
          this.toastr.error(serverError);
        },
      });
  }
  //
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Empêche le menu contextuel par défaut
  }

  /**
  * Download CV.
  *
  * @param {string} cvType - The type of CV to export (e.g., WEGESTU or ESN).
  * @param {number} isAnonymous - Whether to export an anonymous version of the CV (1 : not anonymous, 2 : anonymous) .
  * @returns {void}
  */
  downloadCV(cvType : string, isAnonymous: number){
       if(cvType === this.cvTypeEnum.WEGESTU){
         this.exportCVCandidate(isAnonymous, null)
       }else{
        if (!this.subscriptionCanAccess('CV personnalisé')) return
        this.exportCVCandidate(isAnonymous, this.selectedCandidate?.ESN_id)
       }
   }

  // @TOFIX: duplicated
/**
 * Exports the CV of a candidate based on the specified type and company ID.
 *
 * @param {number} type - The type of CV to export (e.g., 1 for standard, 2 for anonymous)
 * @param {number | null} idCompany - The ID of the company for which the CV is being exported.
 *                          Use `null` if no specific company is associated.
 */
exportCVCandidate(type: number, idCompany : number | null) {

  this.spinner.show();

  const candidate = {
    ids: [this.idCandidat],
    last_name: this.selectedCandidate?.last_name,
    first_name: this.selectedCandidate?.first_name
  } 
  
  const exportMethod = idCompany !== null
    ? this.exportService.exportCVEsnCandidate(candidate, type, idCompany)
    : this.exportService.exportCVWegestuCandidate(candidate, type);

  exportMethod.subscribe({
    next: () => {
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    },
  });
}
/**
 * Checks if a candidate is an ESN consultant and belongs to the current user's ESN
 *
 * @param roles - candidate's roles
 * @returns boolean - Returns true if the candidate is an ESN consultant and belongs to the current user's ESN
 */
  checksEsnConsultant(roles: string[]): boolean {
    return roles.includes(this.ESN_CONSULTANT_ROLE) ||
    this.currentUser?.company?.uuid === this.selectedCandidate?.ESN_id;
}

//@TOFIX: duplicated
/**
 * Redirects to a specified URL. Opens the URL in a new tab if `isBlank` is `true`.
 * 
 * @param url - The URL to redirect to.
 * @param isBlank - If `true`, opens the URL in a new tab; otherwise, navigates in the same tab.
 */
redirectTo(url: string, isBlank: boolean): void {
  if (!url) {
    return;
  }
  if (isBlank) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
}

subscriptionCanAccess(featureName: string): boolean {
  return this.subscriptionService.subscriptionCanAccess(featureName);
}

unSubscribedEsn(): boolean {
  return this.subscriptionService.unSubscribedEsn();
}

downloadCVOriginal() {
  this.spinner.show();
  let candidateCvData = {
    fileNames: this.selectedCandidate != null ? [this.selectedCandidate?.cv] : [],
    last_name: this.selectedCandidate?.last_name,
    first_name: this.selectedCandidate?.first_name
  } 

  this.exportService.exportCVCandidate(candidateCvData).subscribe({
    next: () => {
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    },
  });
}

}
